import React from 'react';
import PropTypes from 'prop-types';
import cn from '../../../utils/tools/cn';

import styles from './TabsToggle.module.scss';

function TabsToggle({
  tabs, active, setActive, className, disabled,
}) {
  return (
    <div className={cn([styles.container, 'd-inline-flex a-center', className])}>
      {tabs?.map((tab, index) => (
        <button
          key={index}
          type="button"
          className={cn([
            styles.tab,
            active?.value === tab.value ? styles.active : '',
            'fs-14 font-secondary fw-600 c-pointer',
          ])}
          onClick={() => setActive(tab)}
          disabled={tab.disabled || disabled}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

TabsToggle.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({})),
  active: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  setActive: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

TabsToggle.defaultProps = {
  tabs: [],
  active: null,
  setActive: () => {},
  className: '',
  disabled: false,
};

export default TabsToggle;
